const theTeam = {
  title: "L'ÉQUIPE",
  isabelle: {
    position: "Fondatrice et professeur d’anglais",
    paragraphs: [
      "En tant qu’enseignante, il m’est parfois arrivé de sortir de cours avec un grand sentiment de frustration et d’échec, car je n’avais pas réussi à capter l’attention de mes élèves et je les avais « perdus ». Je passais alors mon temps à chercher les méthodes, thèmes et activités qui pourraient faciliter leur intérêt, tout en étant convaincue qu’une partie de la solution était la mise en place d’une pédagogie différenciée.",
      "C’est pourquoi j’ai décidé de créer iizenglish qui permet à l’enseignant de proposer à ses élèves des tâches différentes simultanément. Ainsi en répondant aux besoins différents de chaque élève, iizenglish permet de tous les faire progresser.",
    ],
  },
  herve: {
    position: "Cofondateur et chef de projet",
    paragraphs: [
      "Des années d’expérience à l’international sur des projets complexes.",
      "Son expertise technique et sa logique d’ensemble ont permis la mise en musique des exercices avec l’application.",
    ],
  },
  kayla: {
    position: "Professeur d’anglais",
    paragraphs: [
      "Elle a à cœur de trouver des solutions et des outils pour faire ressortir le meilleur de chaque élève.",
      "De nationalité anglaise, elle est notre référence dans la langue de Shakespeare.",
    ],
  },
  developers: {
    position: "L'équipe de développeurs",
    paragraphs: [
      "Ils et elles codent et aussi « décodent » pour rendre iizenglish intuitif et facile à utiliser.",
    ],
  },
  bodz: {
    position: "Artiste et « traducteur » visuel",
    paragraphs: [
      "Il a relevé le défi et réalisé avec panache les 1275 planches qui agrémentent les exercices.",
      "{'@'}lunetlautre.fr",
    ],
  },
  bottomSection: {
    title: "MAIS NOUS NE SERIONS RIEN SANS :",
    leftSection: {
      title: "LES PIONNIERS",
      content:
        "Les enseignants qui nous ont fait confiance et ont accepté de tester notre bêta version.",
    },
    rightSection: {
      title: "UN SOUTIEN FORT",
      content:
        "Les parents et les élèves qui nous ont fait part de leur expérience des devoirs à la maison.",
    },
  },
};

export default theTeam;
